<template>
  <div class="chart-page">
    <div class="chart-toolbar">
      <div class="toolbar-row">
        <pods-input ref="podsInput" />
        <div class="toolbar-actions">
          <PadCycleFilters />
        </div>
      </div>
      <div class="toolbar-row">
        <DatePicker />
      </div>
    </div>
    <div class="app-card" v-loading="loading">
      <div
        id="connection-chart"
        :style="{ width: '100%', height: '400px' }"
      ></div>
    </div>
  </div>
</template>

<script>
import PodsInput from '@/components/PodsInput'
import DatePicker from '@/components/DatePicker'
import $ from 'jquery'
import swal from 'sweetalert'
import ApiService from '@/services/CommonApiService.js'
import moment from 'moment-timezone'
import PadCycleFilters from '@/components/pods/chartData/PadCycleFilters'
export default {
  data() {
    return {
      chart: '',
      loading: false,
      source: []
    }
  },
  props: {
    tooltip: {
      require: true
    }
  },
  components: {
    PodsInput,
    DatePicker,
    PadCycleFilters
  },
  mounted: function() {
    $('#connection-chart').css('width', $('.page-content').width() + 'px')
    this.getData()
  },
  watch: {
    '$store.state.pods.selectedPod': function() {
      this.getData()
    },
    '$store.state.pods.selectedDate': function() {
      this.getData()
    },
    '$store.state.pods.selectedUtcOffset': function() {
      this.getData()
    }
  },
  methods: {
    getData() {
      if (!this.$store.state.pods.selectedPod.podId) return false
      this.loading = true
      ApiService.GetConnectionReadings(
        this.$store.state.pods.selectedPod.podId,
        this.$store.state.pods.selectedDate[0],
        this.$store.state.pods.selectedDate[1],
        moment.tz(this.$store.state.pods.selectedUtcOffset).utcOffset() / 60
      )
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.source = [['timeStampWithUtc', 'connectionStatus']]
            response.data.data.data.forEach(item => {
              this.source.push([
                moment
                  .utc(item.timeStamp)
                  .tz(this.$store.state.pods.selectedUtcOffset)
                  .format('YYYY-MM-DD HH:mm:ss'),
                item.connectionStatus
              ])
            })
            if (this.source.length <= 1) {
              this.source.push(['', 0])
            }
            this.initChart()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.message
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    initChart() {
      let vm = this
      var dom = document.getElementById('connection-chart')
      this.chart = this.echarts.init(dom)
      this.chart.setOption({
        grid: {
          left: 0,
          right: 20,
          bottom: 50,
          top: 20,
          containLabel: true
        },
        tooltip: this.tooltip,
        color: ['#008ffb'],
        xAxis: [
          {
            type: 'time',
            boundaryGap: false,
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              showMinLabel: true,
              showMaxLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: 1,
            axisLine: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#f2f2f2'],
                width: 1,
                type: 'solid'
              }
            }
          }
        ],
        dataZoom: [
          {
            show: true,
            height: 25,
            bottom: 25,
            start: 0,
            zoomOnMouseWheel: true,
            moveOnMouseMove: true
          },
          {
            type: 'inside'
          }
        ],
        dataset: {
          dimensions: ['timeStampWithUtc', 'connectionStatus'],
          source: this.source
        },
        series: [
          {
            name: 'Connection Status',
            type: 'line',
            symbol: 'circle',
            smooth: true,
            encode: {
              x: 'timeStampWithUtc',
              y: 'connectionStatus'
            }
          }
        ]
      })
      window.addEventListener('resize', function() {
        vm.chart.resize()
      })
    }
  },
  beforeDestroy() {
    if (this.chart) this.chart.clear()
  }
}
</script>
